<template>
  <div class="tab-container">
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <div class="transaction__table">
        <div class="transaction__table-row transaction__table-row--head">
          <div class="transaction__table-col">Date</div>
          <div class="transaction__table-col">Debit</div>
          <div class="transaction__table-col">Credit</div>
          <div class="transaction__table-col">Item / Description</div>
          <div class="transaction__table-col">Account</div>
          <div class="transaction__table-col"></div>
        </div>
        <div v-for="transaction of table_data" :key="transaction.id" class="transaction__table-row">
          <div class="transaction__table-col"><b>{{ dateFormat(transaction.date) }}</b></div>
          <div class="transaction__table-col">
            <template v-if="transaction.is_transfer">
              <b v-if="transaction.transfer_transaction_to" class="transaction__table-amount transaction__table-amount--green">
                {{ new Intl.NumberFormat('en-US', {minimumFractionDigits: 2}).format(transaction.transfer_transaction_to.amount) }} {{ transaction.transfer_transaction_to.account.currency.code }}
              </b>
            </template>
            <template v-else>
              <b v-if="transaction.type === 1" class="transaction__table-amount transaction__table-amount--green">
                {{ new Intl.NumberFormat('en-US', {minimumFractionDigits: 2}).format(transaction.amount) }} {{ transaction.account.currency.code }}
              </b>
              <span v-else>-</span>
            </template>
          </div>
          <div class="transaction__table-col">
            <template v-if="transaction.is_transfer">
              <b class="transaction__table-amount transaction__table-amount--red">
                -{{ new Intl.NumberFormat('en-US', {minimumFractionDigits: 2}).format(transaction.amount) }} {{ transaction.account.currency.code }}
              </b>
            </template>
            <template v-else>
              <b v-if="transaction.type === 2" class="transaction__table-amount transaction__table-amount--red">
                -{{ new Intl.NumberFormat('en-US', {minimumFractionDigits: 2}).format(transaction.amount) }} {{ transaction.account.currency.code }}
              </b>
              <span v-else>-</span>
            </template>
          </div>
          <div class="transaction__table-col transaction__table-col--flex-col">
            <b v-if="transaction.is_transfer">Transfer funds</b>
            <template v-else>
              <button
                v-if="transaction.items.length > 1"
                v-tooltip="{
                  content: tooltipContentCashflowItems(transaction),
                  placement: 'right',
                  offset: 10,
                  html: true,
                  trigger: 'click',
                  classes: 'tooltip-cashflow'
                }"
                class="transaction__table-btn"
              >
                {{ transaction.items.length }} items
              </button>
              <template v-else>
                <b v-if="transaction.type === 1">{{ transaction.items[0]?.item.name_revenue }}</b>
                <b v-if="transaction.type === 2">{{ transaction.items[0]?.item.name_expense }}</b>
              </template>
            </template>
            <span v-if="transaction.description" class="transaction__table-description">{{ transaction.description }}</span>
          </div>
          <div class="transaction__table-col transaction__table-col--flex-col">
            <template v-if="transaction.is_transfer">
              <b v-if="transaction.transfer_transaction_to">{{ transaction.transfer_transaction_to.account.name }}</b>
              <b>{{ transaction.account.name }}</b>
            </template>
            <b v-else>{{ transaction.account.name }}</b>
          </div>
          <div v-if="!transaction.is_transfer && (is_general_manager || is_accountant_supervisor)" class="transaction__table-col transaction__table-col--flex">
            <button @click="onShowDeleteModal(transaction)" type="button">
              <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
            </button>
          </div>
        </div>
      </div>
    </template>
    <modal
      name="delete-transaction-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete-transaction-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete transaction
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this transaction?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete-transaction-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteTransaction" ref="delete_transaction">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import {
  deleteFinanceFundRequestsCashflow,
  getFinanceFundRequestsCashflowList,
  getFinanceTransactionsItemsList,
} from '@/http'
import { format, parse } from 'date-fns'

export default {
  name: 'FinanceFundRequestsDetailCashflow',
  data() {
    return {
      page_loaded: false,
      table_data: [],
      form: {
        date: format(new Date(), 'yyyy-MM-dd'),
        items: [{}],
      },
      transaction_to_action: null,
      // account_options: [],
      transaction_items_options: [],
    }
  },
  validations: {
    form: {
      account: {
        required: requiredIf(function() {
          return !this.transaction_to_action
        })
      },
      date: {
        required: requiredIf(function() {
          return !this.transaction_to_action
        })
      },
      description: {required},
      items: {
        $each: {
          amount: {required},
          item: {required},
        }
      }
    },
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_accountant_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('accountant_supervisor')
    },
  },
  created() {
    this.fetchItems()
    // getFinanceAccounts({ outcome: true }).then(response => { this.account_options = response.data })
    getFinanceTransactionsItemsList({ expense: true })
      .then(response => {
        this.transaction_items_options = response.data
      })
  },
  methods: {
    fetchItems() {
      getFinanceFundRequestsCashflowList(Number(this.$route.params.id))
        .then(response => {
          this.table_data = response.data
          this.page_loaded = true
        })
    },
    // onCheckForm() {
    //   this.$v.form.$touch()
    //   if (this.$v.form.$invalid) {
    //     this.$notify({
    //       type: 'info',
    //       title: 'Check that the form fields are filled in correctly',
    //     })
    //   } else {
    //     this.sendForm()
    //   }
    // },
    // sendForm() {
    //   this.$refs.submit.preload = true
    //   if (!this.transaction_to_action) {
    //     postFinanceFundRequestsCashflow(Number(this.$route.params.id), this.normalizeForm())
    //       .then(() => {
    //         this.fetchItems()
    //         this.$refs.submit.preload = false
    //         this.$modal.hide('transaction-modal')
    //       })
    //       .catch(() => { this.$refs.submit.preload = false })
    //   } else {
    //     patchFinanceFundRequestsCashflow(Number(this.$route.params.id), this.transaction_to_action.id, this.normalizeForm())
    //       .then(() => {
    //         this.fetchItems()
    //         this.$refs.submit.preload = false
    //         this.$modal.hide('transaction-modal')
    //       })
    //       .catch(() => { this.$refs.submit.preload = false })
    //   }
    // },
    // normalizeForm() {
    //   const form = {...this.form}
    //
    //   if (!this.transaction_to_action) form.account = form.account.id
    //   form.items = form.items.map(({amount, item}) => ({
    //     amount,
    //     item: item.id,
    //   }))
    //
    //   return form
    // },
    onShowModal(transaction) {
      this.transaction_to_action = transaction
      if (!transaction) {
        this.form = {
          date: format(new Date(), 'yyyy-MM-dd'),
          items: [{}],
        }
      } else {
        this.form = {
          description: transaction.description,
          items: transaction.items,
        }
      }
      this.$v.form.$reset()
      this.$modal.show('transaction-modal')
    },
    onShowDeleteModal(transaction) {
      this.transaction_to_action = transaction
      this.$modal.show('delete-transaction-modal')
    },
    onDeleteTransaction() {
      this.$refs.delete_transaction.preload = true
      deleteFinanceFundRequestsCashflow(Number(this.$route.params.id), this.transaction_to_action.id)
        .then(() => {
          this.fetchItems()
          this.$refs.delete_transaction.preload = false
          this.$modal.hide('delete-transaction-modal')
        })
        .catch(() => {
          this.$refs.delete_transaction.preload = false
        })
    },
    // onAddItem() {
    //   this.form.items.push({})
    // },
    // onRemoveItem(index) {
    //   this.form.items.splice(index, 1)
    // },
    tooltipContentCashflowItems(transaction) {
      let content = ''
      transaction.items.forEach(({item, amount}) => {
        content += `<span><b>Item:</b> ${transaction.type === 1 ? item.name_revenue : item.name_expense} <b>Amount:</b> ${new Intl.NumberFormat('en-US', {minimumFractionDigits: 2}).format(amount)} ${transaction.account.currency.code}`
      })
      return content
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
  }
}
</script>

<style scoped lang="sass">
.transaction__table
  background-color: #fff

.transaction__table-row
  display: grid
  align-items: center
  grid-template-columns: 120px 180px 180px 1fr 185px 80px
  border: 1px solid #eaeaea
  border-top: none

  &:first-child
    border-color: #f6f6f6
    background-color: #f6f6f6
    border-radius: 5px 5px 0 0

.transaction__table-row--head .transaction__table-col
  font-weight: 500

.transaction__table-col
  padding: 10px 12px

  b
    font-weight: 500

.transaction__table-btn
  font-weight: 500
  text-align: left
  transition: color 0.3s

  &:hover
    color: $color-theme

.transaction__table-col--flex-col
  display: flex
  flex-direction: column
  align-items: flex-start
  gap: 3px

.transaction__table-col--flex
  display: flex
  gap: 10px
  align-items: center
  justify-content: center

  button
    line-height: 0
    transition: transform 0.2s

    &:hover
      transform: translateY(-1px)

    img
      width: 25px
      height: 25px

.transaction__table-amount--green
  color: $color-theme

.transaction__table-amount--red
  color: #e85c20

.transaction__table-description
  color: #626262
  font-size: 13px

.transaction__table-balance
  position: relative
  padding-left: 20px

  &:before
    content: ''
    position: absolute
    left: 8px
    top: 5px
    width: 8px
    height: 5px

.transaction__table-balance--minus:before
  background-image: url("~@/assets/img/balance-minus.svg")

.transaction__table-balance--plus:before
  background-image: url("~@/assets/img/balance-plus.svg")
</style>
